import { Typography } from "@kitbird/core";
import { ReactComponent as EmptyAvatar } from "../../../../../assets/images/empty-avatar.svg";
import { ReactComponent as RightCornerBg } from "../../../../../assets/images/right-corner-simple-bg.svg";

interface DetailUserAccountProps {
  userNip: string;
  userName: string;
  userEmail: string;
  showNip?: boolean;
  isOnTable?: boolean;
  showBg?: boolean;
}
const DetailUserAccount = ({
  userEmail,
  userName,
  userNip,
  showNip = true,
  isOnTable = true,
  showBg = false,
}: DetailUserAccountProps) => {
  const config = {
    avatar: {
      width: isOnTable ? 40 : 56,
      height: isOnTable ? 40 : 56,
    },
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        gap: isOnTable ? "8px" : "20px",
      }}
    >
      <EmptyAvatar {...config.avatar} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography level={isOnTable ? 6 : 4} fontWeight="bold">
          {showNip && <span>{userNip} &bull; </span>}
          {userName}
        </Typography>
        <Typography level={isOnTable ? 7 : 5} fontWeight="regular">
          {userEmail}
        </Typography>
      </div>
      {showBg && (
        <RightCornerBg
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            display: showBg ? "block" : "none",
          }}
        />
      )}
    </div>
  );
};

export default DetailUserAccount;
